import { RemoteGetAllOrganizationsUser } from 'data/usecases';
import { GetAllOrganizationsUserUseCaseInterface } from 'domain/usecases';
import { makeApiUrlOrganizationsUser } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllOrganizationsUser =
  (): GetAllOrganizationsUserUseCaseInterface =>
    new RemoteGetAllOrganizationsUser(
      makeApiUrlOrganizationsUser(),
      makeAxiosHttpClient(),
    );
